import React from 'react';
import {
  Row, Col, Card, Button, ListGroup, ListGroupItem
} from 'reactstrap';
import { removeIndexFromPath } from 'settings/shared/commonMethod';


export default class SelectedCompare extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() { }

  render() {
    return (
      this.props.arrayOfCheckboxSelectedFiles !== null && this.props.arrayOfCheckboxSelectedFiles.length > 0 && <Row className='selected-back mt-1 mb-1'>

        <Col lg={8}>
        {this.props.arrayOfCheckboxSelectedFiles.map((item) => (<><small title={removeIndexFromPath(item)} className='text-primary font-weight-bold 
            overflowStyle'>{removeIndexFromPath(item)}</small></>))}
            </Col>

            {this.props.arrayOfCheckboxSelectedFiles.length > 1 && <Col lg={4}
            className='d-flex justify-content-end align-items-center text-center actionicon' onClick={() => {this.props.checkBothFiles()}}><span className='compare-diff-font'>
              <i class="fas fa-code fa-lg compare-diff-font pr-1" title="Compare"></i>Compare</span>
          </Col>}
      </Row>
      )
  }
}
